// ------------- CONTENTS: --------------------------------------------
// - SAME HEIGHT TITLE + SUBTITLE in "NEW ARRIVALS"
// --------------------------------------------------------------------

// --------------------------------------------------
// SAME HEIGHT TITLE + SUBTITLE in "NEW ARRIVALS"
// --------------------------------------------------
$(function () {

    function equalizeHeights(selector) {
        if (window.innerWidth >= 768) {
            $(selector).css('min-height', '');
            return;
        }

        $(selector).css('min-height', '');

        for (let i = 0; i < $(selector).length; i += 2) {
            const $pair = $(selector).slice(i, i + 2);

            let maxHeight = 0;

            $pair.each(function () {
                maxHeight = Math.max(maxHeight, $(this).outerHeight());
            });

            $pair.css('min-height', maxHeight);
        }
    }

    function updateHeights() {
        equalizeHeights('.new-arrivals .collection-item__heading');
        equalizeHeights('.new-arrivals .collection-item__sub');
    }

    $(window).on('load resize', updateHeights);
    updateHeights();

});